import React, { useMemo } from "react";
import { Table } from "../../../../../shared/Table/Table";
import classes from "../../../newBusinessInsightsContent.module.scss";
import { useStaffAsPatients } from "./hooks/useStaffAsPatients";
import Header from "../../../components/Header";
import { useHeaderActions } from "../../../hooks/useHeaderActions";
import { Box } from "../../../../../shared/Box/Box";
import { Skeleton } from "../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../shared/Empty/Empty";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

const modalInfo = {
  title: "staffTreatmentReport.info.title",
  rows: ["staffTreatmentReport.info.note"],
};

const StaffAsPatients = () => {
  const { selectedClinic, period, apiPeriod } = useHeaderActions();
  const requestParams = {
    fromDate: apiPeriod.fromDate,
    toDate: apiPeriod.toDate,
    clinic_id:
      selectedClinic.value.value !== 0 ? [selectedClinic.value.value] : [],
  };
  const { data, isLoading } = useStaffAsPatients(requestParams);

  const isTableDataEmpty = !isLoading && !data?.staffAsPatients?.length;

  const patientsData = useMemo(() => {
    if (!data?.staffAsPatients) return [];

    return data.staffAsPatients.flatMap((staffPatient) => {
      return (staffPatient.data || staffPatient.invoices || []).map(
        (invoice, _index) => {
          return {
            staffMemberName:
              invoice.staff_member_name ||
              invoice.firstname + " " + invoice.lastname,
            firstName: invoice.firstname,
            lastName: invoice.lastname,
            treatmentDate: invoice.payment_datetime,
            providerName: invoice.provider_name,
            invoiceNumber: invoice.invoice_number,
            invoiceItems: invoice.items,
            totalAmount: invoice.total_amount,
            discountAmount: invoice.discount_amount,
          };
        },
      );
    });
  }, [data]);

  const clinics =
    useMemo(
      () =>
        data?.clinics?.map((clinic) => ({
          label: clinic.clinic_name,
          value: clinic.id,
        })),
      [data],
    ) || [];

  const tableColumns = [
    { data: "First Name", accessor: "firstName" },
    { data: "Last Name", accessor: "lastName" },
    { data: "Treatment Date", accessor: "treatmentDate" },
    { data: "Provider", accessor: "providerName" },
    { data: "Invoice #", accessor: "invoiceNumber" },
    { data: "Items", accessor: "invoiceItems" },
    { data: "Total Amount", accessor: "totalAmount" },
    { data: "Discount", accessor: "discountAmount" },
  ];

  return (
    <div className="flex-col font-14 gap-16">
      <Header
        title="Staff as Patients"
        selectedClinic={selectedClinic}
        clinics={clinics}
        period={period}
        downloadRoute={HTTP_ENDPOINTS.getStaffTreatments()}
        requestParams={requestParams}
        modalInfo={modalInfo}
      />
      <div className="flex-col gap-16">
        <div className={classes.tableContainer}>
          <Table bgColor="white" cols={tableColumns} data={patientsData} />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isTableDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default StaffAsPatients;
